<app-loader></app-loader>
<router-outlet *ngIf="show"></router-outlet>